import { createContext, useContext } from "react"
import type { DrawerNavContext } from "@/lib/drawer-trail"

// Exposes the active drawer's `DrawerNavContext` to deeply-
// nested rows inside a drawer entry body (CON-195) without
// prop-drilling through ActivityFeed → CallRowBody.
//
// Why this exists: a call row's "Open call" must behave
// differently depending on where the row is mounted. Inside a
// drawer entry body it should `pushDrawer("call", …)` so the
// call opens WITHIN the slideover trail (the bug fix — opening
// the floating rail behind the drawer was wrong). On a
// deal/contact show page or the inbox thread, no drawer is
// open, so the row falls back to the floating transcript
// viewer. The presence of this context is exactly that
// "am I inside a drawer?" signal.
//
// Returns null when no drawer entry wraps the consumer (show
// pages, inbox thread, isolated tests) so callers degrade to
// the floating viewer.
export const DrawerNavContextValue =
  createContext<DrawerNavContext | null>(null)

export function useDrawerNavContext(): DrawerNavContext | null {
  return useContext(DrawerNavContextValue)
}
